export default "__VITE_ASSET__5_RlqP_s__"